module.exports = __webpack_public_path__ + "img/barrier-climb.8be7c0d.jpg";